<ng-container
  *ngIf="{
    isLogged: isLogged$ | async,
  } as content"
>
  @if (entry && entry.product) {
    <div class="container-entry">
      <div class="box-image">
        <product-media [product]="entry.product"></product-media>
      </div>

      <div class="box-details">
        <h3 class="box-product-name" [title]="entry.product?.name">
          @if (!entry.product?.isCustom) {
            <a
              class="text-common"
              tabindex="0"
              [target]="targetURL"
              [routerLink]="['/p/' + entry.product?.code]"
              [innerHTML]="fixProductName(entry.product?.name)"
            >
            </a>
          } @else {
            <span class="text-common" [innerHTML]="fixProductName(entry.product?.name)"> </span>
          }
        </h3>

        <div class="inner-container">
          <div class="box-codes">
            @if (content.isLogged) {
              <p *ngIf="entry.product?.customerPartNumber">
                <span class="title">{{ 'intro.customer' | cxTranslate }}#:</span>
                <span class="value">{{ entry.product?.customerPartNumber }}</span>
              </p>
            }

            <p *ngIf="entry.product?.partNumber">
              <span class="title">{{ 'intro.part' | cxTranslate }}#:</span>
              <span class="value">{{ entry.product?.partNumber }}</span>
            </p>

            <p *ngIf="entry.product?.catalogNumber">
              <span class="title">{{ 'intro.catalog' | cxTranslate }}#:</span>
              <span class="value">{{ entry.product?.catalogNumber }}</span>
            </p>
          </div>

          <div class="box-price">
            @if (!entry.product?.isCustom) {
              @if (!entry.product?.discontinued) {
                <div class="box-price" [ngClass]="{ 'is-logged': content.isLogged }">
                  <product-price [InProduct$]="product2Observable(entry.product!)" [lazyPrice]="true"></product-price>
                </div>
              } @else {
                <span class="ff-bold text-danger">
                  {{ 'productRow.noLonger' | cxTranslate }}
                </span>
              }
            }
          </div>

          <div class="box-qty">
            <div class="container-qty">
              <span class="title">
                {{ 'cart.cartItems.quantity' | cxTranslate }}
              </span>

              <div role="cell" class="cx-quantity">
                <div class="cx-value">
                  @if (getControl()) {
                    <cx-item-counter [control]="getControl()" [allowZero]="true"></cx-item-counter>
                  }
                </div>

                <button class="btn btn-link text-center w-100" (click)="removeItem()">
                  {{ 'common.remove' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-container>
